export const translations = {
  en: {
    // Header
    headerTitle: "United States of Africa. Kingdom of Kush Youth Parliament",
    search: "Search",
    home: "Home",
    members: "Members",
    plenary: "Plenary",
    committees: "Committees",
    documents: "Documents",
    about: "About",
    
    // Home Page
    heroTitle: "United States of Africa.\nKingdom of Kush Youth Parliament",
    heroSubtitle: "Empowering the next generation of African leaders to shape policies and drive continental progress",
    meetMembers: "Meet Our Members",
    learnMore: "Learn More",
    
    // Stats
    statMembers: "Members",
    statCountries: "Countries",
    statCommittees: "Committees",
    statPoliticalGroups: "Political Groups",
    statSessions: "Sessions 2025",
    statBillsPassed: "Bills Passed",
    
    // News
    latestNews: "Latest News",
    viewAllNews: "View All News",
    readMore: "Read More",
    
    // Quick Access
    quickAccess: "Quick Access",
    membersDirectory: "Members Directory",
    membersDirectoryDesc: "Browse our 550 members from across Africa",
    plenarySessions: "Plenary Sessions",
    plenarySessionsDesc: "Watch live and recorded parliamentary sessions",
    committeesTitle: "Committees",
    committeesDesc: "Explore our 60 specialized committees",
    documentsTitle: "Documents",
    documentsDesc: "Access legislative documents and reports",
    
    // CTA
    joinMovement: "Join the Movement",
    joinMovementDesc: "Be part of shaping Africa's future. Engage with our initiatives and contribute to continental development.",
    getInvolved: "Get Involved",
    subscribeUpdates: "Subscribe to Updates",
    
    // Members Page
    parliamentMembers: "Parliament Members",
    meetLeaders: "Meet the 550 youth leaders representing Africa's future",
    searchPlaceholder: "Search by name or country...",
    filterByGroup: "Filter by Political Group",
    filterByCountry: "Filter by Country",
    allGroups: "All Political Groups",
    allCountries: "All Countries",
    politicalGroups: "Political Groups",
    showing: "Showing",
    of: "of",
    membersText: "members",
    previous: "Previous",
    next: "Next",
    page: "Page",
    staffMembers: "Staff Members",
    contact: "Contact",
    
    // Plenary Page
    plenarySessionsTitle: "Plenary Sessions",
    plenarySubtitle: "Watch live sessions and access recordings of parliamentary proceedings",
    nextSession: "Next Session",
    joinLiveStream: "Join Live Stream",
    upcomingSessions: "Upcoming Sessions",
    pastSessions: "Past Sessions",
    sessionAgenda: "Session Agenda",
    watchLive: "Watch Live",
    watchRecording: "Watch Recording",
    viewTranscript: "View Transcript",
    videoArchive: "Video Archive",
    viewAllVideos: "View All Videos",
    
    // Committees Page
    parliamentaryCommittees: "Parliamentary Committees",
    committeesSubtitle: "Specialized committees working on key policy areas for Africa's development",
    chair: "Chair",
    nextMeeting: "Next Meeting",
    viewDetails: "View Committee Details",
    howCommitteesWork: "How Committees Work",
    policyDevelopment: "Policy Development",
    policyDevelopmentDesc: "Committees draft and review legislation, conduct research, and develop policy recommendations.",
    expertConsultations: "Expert Consultations",
    expertConsultationsDesc: "Committees invite experts, stakeholders, and citizens to provide input on important issues.",
    regularMeetings: "Regular Meetings",
    regularMeetingsDesc: "Committees meet regularly to discuss ongoing work and make decisions on legislative matters.",
    upcomingMeetings: "Upcoming Committee Meetings",
    viewAgenda: "View Agenda",
    
    // Documents Page
    legislativeDocuments: "Legislative Documents",
    documentsSubtitle: "Access official documents, legislation, reports, and policy papers",
    searchDocuments: "Search documents...",
    filterByType: "Filter by Type",
    filterByStatus: "Filter by Status",
    allTypes: "All Types",
    allStatuses: "All Statuses",
    totalDocuments: "Total Documents",
    adopted: "Adopted",
    underReview: "Under Review",
    published: "Published",
    view: "View",
    download: "Download",
    documentCategories: "Document Categories",
    
    // About Page
    aboutTitle: "About the Kingdom of Kush Youth Parliament",
    aboutSubtitle: "Empowering young African leaders to shape the future of the continent through democratic participation, innovative policy-making, and collaborative action.",
    ourMission: "Our Mission",
    missionText: "To provide a platform for African youth to actively participate in governance, develop progressive policies, and drive sustainable development across the continent. We aim to amplify youth voices in decision-making processes and foster a new generation of responsible, visionary leaders committed to Africa's prosperity.",
    ourVision: "Our Vision",
    visionText: "A united, prosperous Africa where youth are at the forefront of shaping policies that address education, healthcare, economic development, environmental sustainability, and social justice. We envision a continent where every young person has the opportunity to contribute to and benefit from Africa's transformation.",
    ourValues: "Our Core Values",
    excellence: "Excellence",
    excellenceDesc: "Striving for the highest standards in policy-making and governance",
    unity: "Unity",
    unityDesc: "Bringing together diverse voices across 55 African nations",
    integrity: "Integrity",
    integrityDesc: "Upholding honesty, transparency, and ethical leadership",
    innovation: "Innovation",
    innovationDesc: "Embracing creative solutions to continental challenges",
    ourJourney: "Our Journey",
    keyAchievements: "Key Achievements",
    representatives: "Representatives",
    fromAcross: "From across Africa",
    in2025: "In 2025 alone",
    youthImpacted: "Youth Impacted",
    throughPrograms: "Through our programs",
    getInvolvedTitle: "Get Involved",
    getInvolvedText: "Join us in shaping Africa's future. Whether you're interested in policy-making, community engagement, or contributing your skills, there's a place for you in the Kingdom of Kush Youth Parliament.",
    applyMembership: "Apply for Membership",
    volunteerWithUs: "Volunteer with Us",
    supportOurWork: "Support Our Work",
    
    // Footer
    footerDesc: "Empowering African youth to shape the future of the continent through democratic participation and progressive legislation.",
    quickLinks: "Quick Links",
    resources: "Resources",
    legislativeObservatory: "Legislative Observatory",
    researchAnalysis: "Research & Analysis",
    policyPapers: "Policy Papers",
    mediaCenter: "Media Center",
    faqs: "FAQs",
    contactUs: "Contact Us",
    africanUnionHQ: "African Union Headquarters",
    addisAbaba: "Addis Ababa, Ethiopia",
    allRightsReserved: "All rights reserved",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    accessibility: "Accessibility",
    
    // Forms
    getInvolvedFormTitle: "Get Involved",
    getInvolvedFormSubtitle: "Join us in shaping Africa's future",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone Number",
    country: "Country",
    areaOfInterest: "Area of Interest",
    selectInterest: "Select your area of interest",
    tellAboutYourself: "Tell us about yourself",
    tellAboutYourselfPlaceholder: "Share your background, skills, and why you want to get involved...",
    submitApplication: "Submit Application",
    submitting: "Submitting...",
    cancel: "Cancel",
    
    subscribeFormTitle: "Subscribe to Updates",
    subscribeFormSubtitle: "Stay informed about our activities",
    optional: "(Optional)",
    emailAddress: "Email Address",
    subscribeText: "You'll receive updates about parliamentary sessions, new legislation, and youth initiatives across Africa.",
    subscribeNow: "Subscribe Now",
    subscribing: "Subscribing...",
    
    contactFormTitle: "Contact Us",
    contactFormSubtitle: "We'd love to hear from you",
    subject: "Subject",
    message: "Message",
    emailDirectly: "Email us directly:",
    sendMessage: "Send Message",
    sending: "Sending...",
    
    // Success Messages
    successTitle: "Success!",
    errorTitle: "Error",
    contactSuccess: "Thank you for contacting us! We'll respond within 24 hours.",
    subscribeSuccess: "Successfully subscribed! You'll receive updates about our parliament.",
    getInvolvedSuccess: "Thank you for your interest! Our team will contact you soon.",
    errorMessage: "Failed to submit. Please try again.",
    
    // Interest Areas
    policyMaking: "Policy Making",
    committeeWork: "Committee Work",
    communityEngagement: "Community Engagement",
    youthAdvocacy: "Youth Advocacy",
    researchAnalysisInterest: "Research & Analysis",
    technologyInnovation: "Technology & Innovation",
    environmentalAction: "Environmental Action",
    economicDevelopment: "Economic Development",
    healthSocialAffairs: "Health & Social Affairs",
    educationCulture: "Education & Culture",
    
    // Categories
    legislative: "Legislative",
    events: "Events",
    environment: "Environment",
    technology: "Technology",
    health: "Health",
    economy: "Economy",
  },
  
  fr: {
    // Header
    headerTitle: "États-Unis d'Afrique. Parlement de la Jeunesse du Royaume de Koush",
    search: "Rechercher",
    home: "Accueil",
    members: "Membres",
    plenary: "Plénière",
    committees: "Comités",
    documents: "Documents",
    about: "À propos",
    
    // Home Page
    heroTitle: "États-Unis d'Afrique.\nParlement de la Jeunesse du Royaume de Koush",
    heroSubtitle: "Autonomiser la prochaine génération de leaders africains pour façonner les politiques et stimuler le progrès continental",
    meetMembers: "Rencontrez nos membres",
    learnMore: "En savoir plus",
    
    // Stats
    statMembers: "Membres",
    statCountries: "Pays",
    statCommittees: "Comités",
    statPoliticalGroups: "Groupes Politiques",
    statSessions: "Sessions 2025",
    statBillsPassed: "Lois Adoptées",
    
    // News
    latestNews: "Dernières Nouvelles",
    viewAllNews: "Voir Toutes les Nouvelles",
    readMore: "Lire la Suite",
    
    // Quick Access
    quickAccess: "Accès Rapide",
    membersDirectory: "Répertoire des Membres",
    membersDirectoryDesc: "Parcourez nos 550 membres à travers l'Afrique",
    plenarySessions: "Sessions Plénières",
    plenarySessionsDesc: "Regardez les sessions parlementaires en direct et enregistrées",
    committeesTitle: "Comités",
    committeesDesc: "Explorez nos 60 comités spécialisés",
    documentsTitle: "Documents",
    documentsDesc: "Accédez aux documents législatifs et rapports",
    
    // CTA
    joinMovement: "Rejoignez le Mouvement",
    joinMovementDesc: "Participez à façonner l'avenir de l'Afrique. Engagez-vous dans nos initiatives et contribuez au développement continental.",
    getInvolved: "Participez",
    subscribeUpdates: "S'abonner aux Mises à Jour",
    
    // Members Page
    parliamentMembers: "Membres du Parlement",
    meetLeaders: "Rencontrez les 550 jeunes leaders représentant l'avenir de l'Afrique",
    searchPlaceholder: "Rechercher par nom ou pays...",
    filterByGroup: "Filtrer par Groupe Politique",
    filterByCountry: "Filtrer par Pays",
    allGroups: "Tous les Groupes Politiques",
    allCountries: "Tous les Pays",
    politicalGroups: "Groupes Politiques",
    showing: "Affichage",
    of: "de",
    membersText: "membres",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    staffMembers: "Membres du Personnel",
    contact: "Contacter",
    
    // Forms
    getInvolvedFormTitle: "Participez",
    getInvolvedFormSubtitle: "Rejoignez-nous pour façonner l'avenir de l'Afrique",
    fullName: "Nom Complet",
    email: "E-mail",
    phone: "Numéro de Téléphone",
    country: "Pays",
    areaOfInterest: "Domaine d'Intérêt",
    selectInterest: "Sélectionnez votre domaine d'intérêt",
    tellAboutYourself: "Parlez-nous de vous",
    tellAboutYourselfPlaceholder: "Partagez votre parcours, vos compétences et pourquoi vous souhaitez participer...",
    submitApplication: "Soumettre la Candidature",
    submitting: "Envoi en cours...",
    cancel: "Annuler",
    
    subscribeFormTitle: "S'abonner aux Mises à Jour",
    subscribeFormSubtitle: "Restez informé de nos activités",
    optional: "(Optionnel)",
    emailAddress: "Adresse E-mail",
    subscribeText: "Vous recevrez des mises à jour sur les sessions parlementaires, les nouvelles lois et les initiatives jeunesse en Afrique.",
    subscribeNow: "S'abonner Maintenant",
    subscribing: "Abonnement...",
    
    contactFormTitle: "Contactez-Nous",
    contactFormSubtitle: "Nous aimerions avoir de vos nouvelles",
    subject: "Sujet",
    message: "Message",
    emailDirectly: "Envoyez-nous un e-mail directement:",
    sendMessage: "Envoyer le Message",
    sending: "Envoi...",
    
    // Success Messages
    successTitle: "Succès!",
    errorTitle: "Erreur",
    contactSuccess: "Merci de nous avoir contactés! Nous répondrons dans les 24 heures.",
    subscribeSuccess: "Abonnement réussi! Vous recevrez des mises à jour sur notre parlement.",
    getInvolvedSuccess: "Merci de votre intérêt! Notre équipe vous contactera bientôt.",
    errorMessage: "Échec de l'envoi. Veuillez réessayer.",
    
    // Interest Areas
    policyMaking: "Élaboration de Politiques",
    committeeWork: "Travail en Comité",
    communityEngagement: "Engagement Communautaire",
    youthAdvocacy: "Plaidoyer pour la Jeunesse",
    researchAnalysisInterest: "Recherche et Analyse",
    technologyInnovation: "Technologie et Innovation",
    environmentalAction: "Action Environnementale",
    economicDevelopment: "Développement Économique",
    healthSocialAffairs: "Santé et Affaires Sociales",
    educationCulture: "Éducation et Culture",
  },
  
  ar: {
    // Header
    headerTitle: "الولايات المتحدة الأفريقية. برلمان شباب مملكة كوش",
    search: "بحث",
    home: "الرئيسية",
    members: "الأعضاء",
    plenary: "الجلسة العامة",
    committees: "اللجان",
    documents: "الوثائق",
    about: "حول",
    
    // Home Page  
    heroTitle: "الولايات المتحدة الأفريقية.\nبرلمان شباب مملكة كوش",
    heroSubtitle: "تمكين الجيل القادم من القادة الأفارقة لصياغة السياسات ودفع التقدم القاري",
    meetMembers: "تعرف على أعضائنا",
    learnMore: "اعرف المزيد",
    
    // Stats
    statMembers: "الأعضاء",
    statCountries: "الدول",
    statCommittees: "اللجان",
    statPoliticalGroups: "المجموعات السياسية",
    statSessions: "جلسات 2025",
    statBillsPassed: "القوانين المعتمدة",
    
    // News
    latestNews: "آخر الأخبار",
    viewAllNews: "عرض جميع الأخبار",
    readMore: "اقرأ المزيد",
    
    // Quick Access
    quickAccess: "وصول سريع",
    membersDirectory: "دليل الأعضاء",
    membersDirectoryDesc: "تصفح أعضائنا الـ 550 من جميع أنحاء أفريقيا",
    plenarySessions: "الجلسات العامة",
    plenarySessionsDesc: "شاهد الجلسات البرلمانية المباشرة والمسجلة",
    committeesTitle: "اللجان",
    committeesDesc: "استكشف لجاننا المتخصصة الـ 60",
    documentsTitle: "الوثائق",
    documentsDesc: "الوصول إلى الوثائق التشريعية والتقارير",
    
    // CTA
    joinMovement: "انضم إلى الحركة",
    joinMovementDesc: "كن جزءًا من تشكيل مستقبل أفريقيا. شارك في مبادراتنا وساهم في التنمية القارية.",
    getInvolved: "شارك معنا",
    subscribeUpdates: "اشترك في التحديثات",
    
    // Members Page
    parliamentMembers: "أعضاء البرلمان",
    meetLeaders: "تعرف على 550 قائدًا شابًا يمثلون مستقبل أفريقيا",
    searchPlaceholder: "البحث بالاسم أو البلد...",
    filterByGroup: "تصفية حسب المجموعة السياسية",
    filterByCountry: "تصفية حسب البلد",
    allGroups: "جميع المجموعات السياسية",
    allCountries: "جميع البلدان",
    politicalGroups: "المجموعات السياسية",
    showing: "عرض",
    of: "من",
    membersText: "الأعضاء",
    previous: "السابق",
    next: "التالي",
    page: "صفحة",
    staffMembers: "موظفو الدعم",
    contact: "اتصل",
    
    // Forms
    getInvolvedFormTitle: "شارك معنا",
    getInvolvedFormSubtitle: "انضم إلينا في تشكيل مستقبل أفريقيا",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    country: "البلد",
    areaOfInterest: "مجال الاهتمام",
    selectInterest: "اختر مجال اهتمامك",
    tellAboutYourself: "أخبرنا عن نفسك",
    tellAboutYourselfPlaceholder: "شارك خلفيتك ومهاراتك ولماذا تريد المشاركة...",
    submitApplication: "إرسال الطلب",
    submitting: "جارٍ الإرسال...",
    cancel: "إلغاء",
    
    subscribeFormTitle: "اشترك في التحديثات",
    subscribeFormSubtitle: "ابق على اطلاع بأنشطتنا",
    optional: "(اختياري)",
    emailAddress: "عنوان البريد الإلكتروني",
    subscribeText: "ستتلقى تحديثات حول الجلسات البرلمانية والتشريعات الجديدة ومبادرات الشباب في جميع أنحاء أفريقيا.",
    subscribeNow: "اشترك الآن",
    subscribing: "جارٍ الاشتراك...",
    
    contactFormTitle: "اتصل بنا",
    contactFormSubtitle: "نود أن نسمع منك",
    subject: "الموضوع",
    message: "الرسالة",
    emailDirectly: "راسلنا مباشرة:",
    sendMessage: "إرسال الرسالة",
    sending: "جارٍ الإرسال...",
    
    // Success Messages
    successTitle: "نجاح!",
    errorTitle: "خطأ",
    contactSuccess: "شكرًا لتواصلك معنا! سنرد خلال 24 ساعة.",
    subscribeSuccess: "تم الاشتراك بنجاح! ستتلقى تحديثات حول برلماننا.",
    getInvolvedSuccess: "شكرًا لاهتمامك! سيتواصل معك فريقنا قريبًا.",
    errorMessage: "فشل الإرسال. يرجى المحاولة مرة أخرى.",
    
    // Interest Areas
    policyMaking: "صنع السياسات",
    committeeWork: "عمل اللجان",
    communityEngagement: "المشاركة المجتمعية",
    youthAdvocacy: "الدفاع عن الشباب",
    researchAnalysisInterest: "البحث والتحليل",
    technologyInnovation: "التكنولوجيا والابتكار",
    environmentalAction: "العمل البيئي",
    economicDevelopment: "التنمية الاقتصادية",
    healthSocialAffairs: "الصحة والشؤون الاجتماعية",
    educationCulture: "التعليم والثقافة",
  },
  
  pt: {
    // Header
    headerTitle: "Estados Unidos da África. Parlamento da Juventude do Reino de Kush",
    search: "Pesquisar",
    home: "Início",
    members: "Membros",
    plenary: "Plenária",
    committees: "Comitês",
    documents: "Documentos",
    about: "Sobre",
    
    // Home Page
    heroTitle: "Estados Unidos da África.\nParlamento da Juventude do Reino de Kush",
    heroSubtitle: "Capacitando a próxima geração de líderes africanos para moldar políticas e impulsionar o progresso continental",
    meetMembers: "Conheça Nossos Membros",
    learnMore: "Saiba Mais",
    
    // Stats
    statMembers: "Membros",
    statCountries: "Países",
    statCommittees: "Comitês",
    statPoliticalGroups: "Grupos Políticos",
    statSessions: "Sessões 2025",
    statBillsPassed: "Projetos Aprovados",
    
    // News
    latestNews: "Últimas Notícias",
    viewAllNews: "Ver Todas as Notícias",
    readMore: "Leia Mais",
    
    // Quick Access
    quickAccess: "Acesso Rápido",
    membersDirectory: "Diretório de Membros",
    membersDirectoryDesc: "Navegue pelos nossos 550 membros de toda a África",
    plenarySessions: "Sessões Plenárias",
    plenarySessionsDesc: "Assista sessões parlamentares ao vivo e gravadas",
    committeesTitle: "Comitês",
    committeesDesc: "Explore nossos 60 comitês especializados",
    documentsTitle: "Documentos",
    documentsDesc: "Acesse documentos legislativos e relatórios",
    
    // CTA
    joinMovement: "Junte-se ao Movimento",
    joinMovementDesc: "Seja parte de moldar o futuro da África. Envolva-se com nossas iniciativas e contribua para o desenvolvimento continental.",
    getInvolved: "Participe",
    subscribeUpdates: "Assinar Atualizações",
    
    // Members Page
    parliamentMembers: "Membros do Parlamento",
    meetLeaders: "Conheça os 550 jovens líderes representando o futuro da África",
    searchPlaceholder: "Pesquisar por nome ou país...",
    filterByGroup: "Filtrar por Grupo Político",
    filterByCountry: "Filtrar por País",
    allGroups: "Todos os Grupos Políticos",
    allCountries: "Todos os Países",
    politicalGroups: "Grupos Políticos",
    showing: "Mostrando",
    of: "de",
    membersText: "membros",
    previous: "Anterior",
    next: "Próximo",
    page: "Página",
    staffMembers: "Membros da Equipe",
    contact: "Contato",
    
    // Forms
    getInvolvedFormTitle: "Participe",
    getInvolvedFormSubtitle: "Junte-se a nós para moldar o futuro da África",
    fullName: "Nome Completo",
    email: "E-mail",
    phone: "Número de Telefone",
    country: "País",
    areaOfInterest: "Área de Interesse",
    selectInterest: "Selecione sua área de interesse",
    tellAboutYourself: "Fale sobre você",
    tellAboutYourselfPlaceholder: "Compartilhe sua experiência, habilidades e por que deseja participar...",
    submitApplication: "Enviar Candidatura",
    submitting: "Enviando...",
    cancel: "Cancelar",
    
    subscribeFormTitle: "Assinar Atualizações",
    subscribeFormSubtitle: "Fique informado sobre nossas atividades",
    optional: "(Opcional)",
    emailAddress: "Endereço de E-mail",
    subscribeText: "Você receberá atualizações sobre sessões parlamentares, novas legislações e iniciativas de jovens em toda a África.",
    subscribeNow: "Assinar Agora",
    subscribing: "Assinando...",
    
    contactFormTitle: "Fale Conosco",
    contactFormSubtitle: "Adoraríamos ouvir de você",
    subject: "Assunto",
    message: "Mensagem",
    emailDirectly: "Envie-nos um e-mail diretamente:",
    sendMessage: "Enviar Mensagem",
    sending: "Enviando...",
    
    // Success Messages
    successTitle: "Sucesso!",
    errorTitle: "Erro",
    contactSuccess: "Obrigado por entrar em contato! Responderemos em 24 horas.",
    subscribeSuccess: "Assinatura bem-sucedida! Você receberá atualizações sobre nosso parlamento.",
    getInvolvedSuccess: "Obrigado pelo seu interesse! Nossa equipe entrará em contato em breve.",
    errorMessage: "Falha ao enviar. Por favor, tente novamente.",
    
    // Interest Areas
    policyMaking: "Formulação de Políticas",
    committeeWork: "Trabalho de Comitê",
    communityEngagement: "Engajamento Comunitário",
    youthAdvocacy: "Advocacia Juvenil",
    researchAnalysisInterest: "Pesquisa e Análise",
    technologyInnovation: "Tecnologia e Inovação",
    environmentalAction: "Ação Ambiental",
    economicDevelopment: "Desenvolvimento Econômico",
    healthSocialAffairs: "Saúde e Assuntos Sociais",
    educationCulture: "Educação e Cultura",
  },
  
  sw: {
    // Header
    headerTitle: "Muungano wa Nchi za Afrika. Bunge la Vijana la Ufalme wa Kush",
    search: "Tafuta",
    home: "Nyumbani",
    members: "Wajumbe",
    plenary: "Mkutano Mkuu",
    committees: "Kamati",
    documents: "Hati",
    about: "Kuhusu",
    
    // Home Page
    heroTitle: "Muungano wa Nchi za Afrika.\nBunge la Vijana la Ufalme wa Kush",
    heroSubtitle: "Kuwapa nguvu kizazi kijacho cha viongozi wa Afrika kuunda sera na kusukuma maendeleo ya bara",
    meetMembers: "Kutana na Wajumbe Wetu",
    learnMore: "Jifunze Zaidi",
    
    // Stats
    statMembers: "Wajumbe",
    statCountries: "Nchi",
    statCommittees: "Kamati",
    statPoliticalGroups: "Vikundi vya Kisiasa",
    statSessions: "Vikao 2025",
    statBillsPassed: "Sheria Zilizopitishwa",
    
    // News
    latestNews: "Habari za Hivi Karibuni",
    viewAllNews: "Tazama Habari Zote",
    readMore: "Soma Zaidi",
    
    // Quick Access
    quickAccess: "Ufikiaji wa Haraka",
    membersDirectory: "Orodha ya Wajumbe",
    membersDirectoryDesc: "Tazama wajumbe wetu 550 kutoka Afrika nzima",
    plenarySessions: "Vikao vya Mkuu",
    plenarySessionsDesc: "Tazama vikao vya bunge moja kwa moja na vilivyorekodiwa",
    committeesTitle: "Kamati",
    committeesDesc: "Chunguza kamati zetu 60 maalum",
    documentsTitle: "Hati",
    documentsDesc: "Fikia hati za kisheria na ripoti",
    
    // CTA
    joinMovement: "Jiunge na Harakati",
    joinMovementDesc: "Kuwa sehemu ya kuunda mustakabali wa Afrika. Shiriki katika miradi yetu na changia maendeleo ya bara.",
    getInvolved: "Shiriki",
    subscribeUpdates: "Jisajili kwa Masasisho",
    
    // Members Page
    parliamentMembers: "Wajumbe wa Bunge",
    meetLeaders: "Kutana na viongozi 550 wa vijana wanaowakilisha mustakabali wa Afrika",
    searchPlaceholder: "Tafuta kwa jina au nchi...",
    filterByGroup: "Chuja kwa Kikundi cha Kisiasa",
    filterByCountry: "Chuja kwa Nchi",
    allGroups: "Vikundi Vyote vya Kisiasa",
    allCountries: "Nchi Zote",
    politicalGroups: "Vikundi vya Kisiasa",
    showing: "Inaonyesha",
    of: "ya",
    membersText: "wajumbe",
    previous: "Iliyotangulia",
    next: "Inayofuata",
    page: "Ukurasa",
    staffMembers: "Wafanyakazi",
    contact: "Wasiliana",
    
    // Forms
    getInvolvedFormTitle: "Shiriki",
    getInvolvedFormSubtitle: "Jiunge nasi kuunda mustakabali wa Afrika",
    fullName: "Jina Kamili",
    email: "Barua Pepe",
    phone: "Nambari ya Simu",
    country: "Nchi",
    areaOfInterest: "Eneo la Kupendezwa",
    selectInterest: "Chagua eneo lako la kupendezwa",
    tellAboutYourself: "Tuambie kuhusu wewe",
    tellAboutYourselfPlaceholder: "Shiriki historia yako, ujuzi, na kwa nini unataka kushiriki...",
    submitApplication: "Wasilisha Ombi",
    submitting: "Inatuma...",
    cancel: "Ghairi",
    
    subscribeFormTitle: "Jisajili kwa Masasisho",
    subscribeFormSubtitle: "Baki ukijua shughuli zetu",
    optional: "(Hiari)",
    emailAddress: "Anwani ya Barua Pepe",
    subscribeText: "Utapokea masasisho kuhusu vikao vya bunge, sheria mpya na miradi ya vijana Afrika nzima.",
    subscribeNow: "Jisajili Sasa",
    subscribing: "Inasajili...",
    
    contactFormTitle: "Wasiliana Nasi",
    contactFormSubtitle: "Tungependa kusikia kutoka kwako",
    subject: "Somo",
    message: "Ujumbe",
    emailDirectly: "Tutumie barua pepe moja kwa moja:",
    sendMessage: "Tuma Ujumbe",
    sending: "Inatuma...",
    
    // Success Messages
    successTitle: "Mafanikio!",
    errorTitle: "Kosa",
    contactSuccess: "Asante kwa kuwasiliana nasi! Tutajibu ndani ya masaa 24.",
    subscribeSuccess: "Usajili umefanikiwa! Utapokea masasisho kuhusu bunge letu.",
    getInvolvedSuccess: "Asante kwa nia yako! Timu yetu itawasiliana nawe hivi karibuni.",
    errorMessage: "Imeshindwa kutuma. Tafadhali jaribu tena.",
    
    // Interest Areas
    policyMaking: "Uundaji wa Sera",
    committeeWork: "Kazi za Kamati",
    communityEngagement: "Ushiriki wa Jamii",
    youthAdvocacy: "Utetezi wa Vijana",
    researchAnalysisInterest: "Utafiti na Uchambuzi",
    technologyInnovation: "Teknolojia na Ubunifu",
    environmentalAction: "Hatua za Mazingira",
    economicDevelopment: "Maendeleo ya Kiuchumi",
    healthSocialAffairs: "Afya na Mambo ya Kijamii",
    educationCulture: "Elimu na Utamaduni",
  }
};
